
import TrafficSafetyQuiz from "../../components/UKG/EnvironmentScience/TrafficSafetyWorksheet";
import LivingNonLivingWorksheet from "../../components/UKG/EnvironmentScience/LivingNonLivingWorksheet";
import TransportVehicleWorksheet from "../../components/UKG/EnvironmentScience/TransportVehicleWorksheet";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/environmental-science/traffic-rules-safety", title: "Traffic Rules & Safety", component: TrafficSafetyQuiz},
    { url: "/ukg/environmental-science/living-non-living-things", title: "Living & Non-Living Things", component: LivingNonLivingWorksheet},
    // { url: "/ukg/environmental-science/water-air-sound-pollution", title: "Water, Air and Sound Pollution"},
    { url: "/ukg/environmental-science/transport-vehicles", title: "Transport & Vehicles", component: TransportVehicleWorksheet},
];


export default topics;